var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRedI(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "red-i",
    d: "M16.441,8.626l-5.173-5.09a1.868,1.868,0,0,0-2.642.022L3.536,8.731a1.868,1.868,0,0,0,.022,2.642l5.173,5.09a1.856,1.856,0,0,0,1.31.536h.016a1.856,1.856,0,0,0,1.317-.558l5.09-5.173a1.868,1.868,0,0,0-.022-2.642ZM9.5,6.833a.5.5,0,0,1,1,0v4a.5.5,0,0,1-1,0Zm.5,6.833A.667.667,0,1,1,10.666,13,.666.666,0,0,1,10,13.666Z",
    transform: "translate(-3 -3)",
    fill: "#e23a45"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedI);
export default __webpack_public_path__ + "static/media/red-i.bf9415b7eac95dda1b194f06c9e3a516.svg";
export { ForwardRef as ReactComponent };